import { useUserStore } from '~/stores';

class Authenticated implements Middleware {
    name() {
        return 'authenticated';
    }

    async run() {
        const userStore = useUserStore();
        if (userStore.loggedIn) return;

        return {
            name: 'login.index',
        };
    }
}

export default new Authenticated();
